const el_id = "omnisend-embedded-v2-6459ae411c89404ab50e3f99";

const product_title = document.currentScript.getAttribute('data-product-title');

var loaded_check_interval = setInterval(function () {
  if (el_loaded(el_id)) {
    clearInterval(loaded_check_interval);
    
    var form_element = document.getElementById(el_id);
    var out_of_stock_input = form_element.querySelector("[name='custom_notify_item']");

    out_of_stock_input.value = product_title;
    out_of_stock_input.classList.add("hide");
  }
}, 500);

function el_loaded(elemId) {
  return (document.getElementById(elemId).hasChildNodes())? true : false;
}


